import { AlertColor } from "../../customEnums/AlertColor";
import { useToastAlertStore } from "../../state/ToastAlertStore";


export const useToastAlert = () => {
    const enqueueAlert = useToastAlertStore((state) => state.enqueueAlert);
    const dismissAlert = useToastAlertStore((state) => state.dismissAlert);
    const clearAlerts = useToastAlertStore((state) => state.clearAlerts);
    const updateAlert = useToastAlertStore((state) => state.updateAlert);

    const notifySuccess = (title: string, message?: string) =>
        enqueueAlert({ title, message, severity: AlertColor.SUCCESS });

    const notifyInfo = (title: string, message?: string) =>
        enqueueAlert({ title, message, severity: AlertColor.INFO });

    const notifyWarning = (title: string, message?: string) =>
        enqueueAlert({ title, message, severity: AlertColor.WARNING });

    const notifyError = (title: string, message?: string) =>
        enqueueAlert({ title, message, severity: AlertColor.ERROR });

    return {
        notifySuccess,
        notifyInfo,
        notifyWarning,
        notifyError,
        enqueueAlert,
        dismissAlert,
        clearAlerts,
        updateAlert,
    };
};
